import {Box, Checkbox} from '@mui/material';
import React, {useCallback, useEffect, useState} from 'react';

import {useAppSelector} from '../../hooks/redux';
import {HumanEmployee, HumanGroupEmployee} from '../../interfaces/HumanGroup';
import {getHumanReadable} from '../../utils/macAddress';
import DataGrid, {DataGridColumn} from '../common/DataGrid';

type TablePropsType = {
  employees: number[];
  allEmployees: HumanGroupEmployee[];
  setFieldValue: (field: string, value: any) => void;
};
export const HumanGroupTable = React.memo(
  ({employees, setFieldValue, allEmployees}: TablePropsType) => {
    const [employeeList, setEmployeeList] = useState<HumanGroupEmployee[]>([]);
    const minerAddressMask = useAppSelector(
      ({assets}) => assets.constants?.miner.address_mask
    );

    const columns: DataGridColumn<HumanEmployee>[] = [
      {
        field: 'checked',
        headerName: 'Selected',
        sortable: true,
        renderCell: ({row}) => (
          <Checkbox
            color="primary"
            checked={employees.includes(row.id)}
            onChange={() => fieldHandle(row.id)}
          />
        ),
      },
      {
        field: 'id',
        headerName: 'ID',
        sortable: true,
        width: 60,
        resizeable: true,
      },
      {
        field: 'employee_asset_id',
        headerName: 'Employee Asset Id',
        width: 120,
        resizeable: true,
        sortable: true,
      },
      {
        field: 'first_name',
        headerName: 'First Name',
        sortable: true,
        width: 100,
        resizeable: true,
      },
      {
        field: 'last_name',
        headerName: 'Last Name',
        sortable: true,
        width: 100,
        resizeable: true,
      },
      {
        field: 'nickname',
        headerName: 'Nickname',
        sortable: true,
        width: 100,
        resizeable: true,
      },
      {
        field: 'network_id',
        headerName: 'Network Id',
        sortable: true,
        width: 100,
        resizeable: true,
        valueGetter: ({row}) => {
          if (row.wifi_enabled) {
            return row.mac_address ? getHumanReadable(row.mac_address) : null;
          }
          if (row.commtrac_external_id && minerAddressMask) {
            // eslint-disable-next-line no-bitwise
            return row.commtrac_external_id & minerAddressMask;
          }
          return row.network_id;
        },
      },
      {
        field: 'type',
        headerName: 'Type',
        sortable: true,
        width: 100,
        resizeable: true,
      },
      {
        field: 'section',
        headerName: 'Section',
        sortable: true,
        width: 100,
        resizeable: true,
      },
    ];

    useEffect(() => {
      setEmployeeList(allEmployees);
    }, [allEmployees]);

    useEffect(() => {
      if (employees.length > 0) {
        const updateEmployees = JSON.parse(JSON.stringify(allEmployees));
        updateEmployees.forEach((item: HumanEmployee) => {
          item.checked = employees.includes(item.id);
        });

        setEmployeeList(updateEmployees);
      }
    }, [employees]);

    const fieldHandle = useCallback(
      (itemId: number) => {
        if (employees.includes(itemId)) {
          setFieldValue(
            'employees',
            employees.filter((el: number) => el !== itemId)
          );
        } else {
          setFieldValue('employees', [...employees, itemId]);
        }
      },
      [employees]
    );

    return (
      <Box width="100%" height={500} overflow="hidden">
        <DataGrid
          rows={employeeList}
          columns={columns}
          pagination
          size="small"
        />
      </Box>
    );
  }
);
